// client/src/coms/views/games_parts/LobbyParts.js
// Lobby pieces shared by every Voxemera game (party games and hosted board/card games): the invitation
// code with copy buttons, the invitation link and the friend invite list. One code format and one link
// for every game: /comms?gameCode=CODE opens the Games destination and joins.
import React, { useState } from 'react';
import UserAvatar from './UserAvatar';

export function inviteLink(code) {
  if (typeof window === 'undefined' || !code) return '';
  return `${window.location.origin}/comms?gameCode=${encodeURIComponent(code)}`;
}

async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}

export function InviteBox({ code, compact = false }) {
  const [copied, setCopied] = useState('');
  if (!code) return null;
  const copy = async (text, what) => {
    if (await copyText(text)) {
      setCopied(what);
      window.setTimeout(() => setCopied(''), 1500);
    }
  };
  return (
    <div className={`party-invite-box${compact ? ' compact' : ''}`} data-testid="invite-box">
      <div className="party-kicker">Invite code</div>
      <div className="party-code" data-testid="party-code">{code}</div>
      <div className="party-row">
        <button type="button" className="party-btn small ghost" onClick={() => copy(code, 'code')}>{copied === 'code' ? 'Copied!' : 'Copy code'}</button>
        <button type="button" className="party-btn small ghost" onClick={() => copy(inviteLink(code), 'link')}>{copied === 'link' ? 'Copied!' : 'Copy link'}</button>
      </div>
    </div>
  );
}

// Friends who are not in the game yet, each with an Invite button.
export function InviteFriends({ friends = [], memberIds = [], busy = false, onInvite }) {
  const present = new Set(memberIds.map(Number));
  const invitable = friends.filter((friend) => !present.has(Number(friend.id)));
  if (!invitable.length || typeof onInvite !== 'function') return null;
  return (
    <details className="party-invite-friends">
      <summary>Invite friends</summary>
      <ul>
        {invitable.map((friend) => (
          <li key={friend.id}>
            <UserAvatar userId={friend.id} name={friend.username} size={22} />
            <span>{friend.username}</span>
            <button type="button" className="party-btn small ghost" disabled={busy} onClick={() => onInvite(friend.id)}>Invite</button>
          </li>
        ))}
      </ul>
    </details>
  );
}

// "Who can join" choices. Games are never open to all of Voxemera: the widest is the server you are in.
export function visibilityOptions({ serverName = '', canvas = false, current = '' } = {}) {
  const options = [];
  if (serverName || current === 'server') options.push({ value: 'server', label: serverName ? `Everyone in ${serverName}` : 'Members of the server' });
  options.push({ value: 'friends', label: 'My friends' });
  if (canvas || current === 'canvas') options.push({ value: 'canvas', label: 'Members of this canvas' });
  options.push({ value: 'invite', label: 'Private: invite code or invited friends' });
  return options;
}
